module.exports = __webpack_public_path__ + "media/images/admin/icons/trash-2-bba7f8a90befcbd8f9c03856bf0b3e29.svg";